import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IBillingInvoicesApiService } from './billing-invoices-api.interface';
import { BillingIntervalUpdateData, BillingInvoices, Invoice } from '../../model/billing-invoice';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { SuccessResponse } from '../shared/success-response';
import { BillingInvoicesMapper } from './billing-invoices-api.mapper';
import { User } from '../../model/user';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';

let API_URL = `${environment.api}`;

@Injectable({
  providedIn: 'root',
})
export class BillingInvoicesApiService implements IBillingInvoicesApiService {
  private http = inject(HttpClient);

  getBillingInvoices(
    userId: User['id'],
    options?: QueryOptions<Invoice>
  ): Observable<BillingInvoices> {
    let params = new HttpParams(); 

    const {page, size} = options ?? {};
    if (page && size) {
      params = params.set('page', page);
      params = params.set('size', size);
    }

    return this.http.get<SuccessResponse>(
      `${API_URL}/users/${userId}/settings/billing-invoices`,
      { params }
    ).pipe(
        map(response => BillingInvoicesMapper.toBillingInvoices(response.data)),
      );
  }

  updateBillingInterval(billing: BillingIntervalUpdateData): Observable<any> {
    return this.http.put(
      API_URL + 'subscription-plan-update',
      JSON.stringify(billing)
    );
  }
}
